// @flow
import {Tag, findMarkdocTag, filterMarkdocTags} from 'docs/util';
import {Href} from 'docs/markdoc/attribute-types';

import type {MarkdocTagRegistration} from 'docs/markdoc';

const Heading = (tag) => tag.name === 'Heading';
const Paragraph = (tag) => tag.name === 'Paragraph';
const IntegrationBuilderDemo = (tag) => tag.name === 'IntegrationBuilderDemo';
const NextSteps = (tag) => tag.name === 'NextSteps';

export const IntegrationBuilder: MarkdocTagRegistration = {
  tag: 'integration-builder',
  component: 'IntegrationBuilder',
  attributes: {
    type: {
      type: String,
      matches: [
        'payments',
        'checkout',
        'webhooks',
        'billing',
        'terminal',
        `invoicing`,
        'card-element',
      ],
      default: '',
    },
    settings: {
      type: String,
      matches: [
        'default',
        'server-only',
        'web-only',
        'web-with-next',
        'terminal',
        'react-only',
      ],
      default: 'default',
    },
    textGuideHref: {
      type: Href,
      required: false,
      default: '',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);

    const title = findMarkdocTag(children, Heading);
    const description = filterMarkdocTags(children, Paragraph);
    const demo = findMarkdocTag(children, IntegrationBuilderDemo);
    const nextSteps = findMarkdocTag(children, NextSteps);

    return new Tag(
      this.tag,
      {...attributes, title, description, demo, nextSteps},
      children,
    );
  },
};
